var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.orderTransactionPutErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderTransactionPutErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.orderTransactionGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderTransactionGetErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "", flat: "", dense: "" } },
                [_c("span", [_vm._v("Add Transaction")])]
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date",
                          type: "date",
                          "error-messages":
                            _vm.orderTransactionPostErrors.date || []
                        },
                        model: {
                          value: _vm.date,
                          callback: function($$v) {
                            _vm.date = $$v
                          },
                          expression: "date"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Amount",
                          type: "number",
                          "error-messages":
                            _vm.orderTransactionPostErrors.amount || []
                        },
                        model: {
                          value: _vm.amount,
                          callback: function($$v) {
                            _vm.amount = _vm._n($$v)
                          },
                          expression: "amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "green",
                            dark: "",
                            loading: _vm.orderTransactionPosting
                          },
                          on: { click: _vm.storeTransaction }
                        },
                        [_c("span", [_vm._v("Add Transaction")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "", flat: "", dense: "" } },
                [
                  _c("span", [_vm._v("History")]),
                  _c("v-spacer"),
                  _vm.orderTransactionGetting
                    ? _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "white" }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c("v-simple-table", {
                attrs: { dense: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Date")]),
                            _c("th", { staticClass: "text-right" }, [
                              _vm._v("Amount")
                            ])
                          ])
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.orderTransactionList, function(item) {
                              return _c("tr", { key: item.id }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      item.date ? item.date.dateFormat() : null
                                    )
                                  )
                                ]),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(_vm._s((item.amount || 0).phpFormat()))
                                ])
                              ])
                            }),
                            _c("tr", [
                              _c("td", { attrs: { colspan: "2" } }, [
                                _vm._v(" ")
                              ])
                            ]),
                            _vm.orderData.vat
                              ? _c("tr", [
                                  _c("th", [
                                    _vm._v(" Total Sales   "),
                                    _c("small", [_vm._v("(VAT Inclusive)")])
                                  ]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalSales.phpFormat()))
                                  ])
                                ])
                              : _vm._e(),
                            _vm.orderData.vat
                              ? _c("tr", [
                                  _c("th", [_vm._v("Less (12% VAT)")]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.vatAmount.phpFormat()))
                                  ])
                                ])
                              : _vm._e(),
                            _vm.orderData.vat
                              ? _c("tr", [
                                  _c("th", [_vm._v("NET of VAT/TOTAL")]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.itemsTotal.phpFormat()))
                                  ])
                                ])
                              : _vm._e(),
                            _vm.orderData.vat
                              ? _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      "Less Withholding (" +
                                        _vm._s(
                                          _vm.withholdingPercentage * 100
                                        ) +
                                        "%)"
                                    )
                                  ]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.withholding.phpFormat()))
                                  ])
                                ])
                              : _vm._e(),
                            _vm.orderData.vat
                              ? _c("tr", [
                                  _c("th", [_vm._v("Total Amount Due")]),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(
                                      _vm._s(_vm.totalAmountDue.phpFormat())
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _c("tr", [
                              _c("th", [_vm._v("Paid")]),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(_vm.totalAmount.phpFormat()))
                              ])
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("Balance")]),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(_vm.balance.phpFormat()))
                              ])
                            ])
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }